export default {
  route: false,
  drawer: false,
  role: null,
  alert: null,
  user: null,
  dialog: null,
  lang: 'de',
  statistic: {},
  loading: false,
  website: 'northitgroup.com',
  subscriber: 0,
  newSubscriberDialog: false,
  updateSubscriberDialog: false
}
